class WorldController {
    public cellsCols: Array<Array<Cell>>;
    public fieldCellsWidth: number;
    public fieldCellsHeight: number;
    public fieldPixelsWidth: number;
    public fieldPixelsHeight: number;
    public cellPixelsSize: number;

    public buildings: Array<Building> = [];
    public bears: Array<Mob> = [];
    public ponies: Array<Mob> = [];
    public cellsWithBuilding: { [building: number]: Array<Cell> } = [];

    private kpsAcc: number = 0;
    private kpsStamp: number = 0;
    private kps: number = 0;

    public constructor(fieldPixelsWidth: number, fieldPixelsHeight: number, cellPixelsSize: number) {
        this.fieldPixelsWidth = fieldPixelsWidth;
        this.fieldPixelsHeight = fieldPixelsHeight;
        this.cellPixelsSize = cellPixelsSize;
        let fieldCellsWidth: number = Math.ceil(fieldPixelsWidth / cellPixelsSize);
        let fieldCellsHeight: number = Math.ceil(fieldPixelsHeight / cellPixelsSize);
        this.fieldCellsWidth = fieldCellsWidth;
        this.fieldCellsHeight = fieldCellsHeight;
        this.cellsCols = [];
        for (let i = 0; i < fieldCellsWidth; i++) {
            let col: Array<Cell> = this.cellsCols[i] = [];
            for (let j = 0; j < fieldCellsHeight; j++) {
                col[j] = new Cell(i, j);
            }
        }
    }

    public getKps(ms: number): number {
        let refreshTimeout = 500;
        let delta = ms - this.kpsStamp;
        if (delta < refreshTimeout) {
            return this.kps;
        }
        this.kps = this.kpsAcc / (refreshTimeout/1000);
        this.kpsStamp = ms;
        this.kpsAcc = 0;
        return this.kps;
    }

    private recheckMovableCells(): void {
        this.cellsWithBuilding = {};
        for (let col of this.cellsCols) {
            for (let cell of col) {
                cell.building = null;
            }
        }
        for (let building of this.buildings) {
            let cell = building.cell;
            let leftDelta = 2;
            // if (building.name == DictNames.defence) {
            //     leftDelta = 2;
            // }
            let cellXTL = DnDUtils.clamp(cell.cellX - leftDelta, 0, this.fieldCellsWidth - 1);
            let cellYTL = DnDUtils.clamp(cell.cellY - 1, 0, this.fieldCellsHeight - 1);
            let cellXBR = DnDUtils.clamp(cell.cellX + 1, 0, this.fieldCellsWidth - 1);
            let cellYBR = DnDUtils.clamp(cell.cellY + 1, 0, this.fieldCellsHeight - 1);

            for (let i = cellXTL; i <= cellXBR; i++) {
                for (let j = cellYTL; j <= cellYBR; j++) {
                    let cell = this.cellsCols[i][j];
                    cell.building = building;
                    let arr = this.cellsWithBuilding[building.uniqId];
                    if (arr) {
                        arr.push(cell);
                    } else {
                        this.cellsWithBuilding[building.uniqId] = [cell];
                    }
                }
            }
        }
    }

    public makeShots(millisecondsAbsolute: number): void {
        for (let building of this.buildings) {
            if (building.lastShot == -1) {
                building.lastShot = millisecondsAbsolute - 15;
            }
            this.makeDefenceShot(building);
            if (building.zombie) {
                continue;
            }
            let delta = millisecondsAbsolute - building.lastShot;
            let numShots = delta / building.reloadTimeout | 0;
            if (numShots >= 1) {
                let shots = building.shots;
                for (let i = 0; i < numShots; i++) {
                    let shot: Shot;
                    if (building.name == DictNames.machineGun) {
                        shot = this.makeMachineGunShot(building);
                    }
                    if (building.name == DictNames.sniper) {
                        shot = this.makeSniperShot(building);
                    }
                    if (building.name == DictNames.mortar) {
                        shot = this.makeSniperShot(building, true);
                    }
                    if (shot) {
                        shots.push(shot);
                    }
                }
                building.lastShot += numShots * building.reloadTimeout;
            } else {
                continue;
            }
        }
    }

    public makeDefenceShot(building: Building): void {
        let cells = this.cellsWithBuilding[building.uniqId];
        if (!cells) {
            return;
        }

        for (let cell of cells) {
            let actors: Array<Mob>;
            if (building.name == DictNames.defence) {
                actors = cell.actors.concat();
                for (let target of actors) {
                    if (target instanceof Building) {
                        continue;
                    }
                    let attack = building.attack();
                    if (attack > target.armor) {
                        let dmg = building.damage();
                        target.health -= dmg;
                        if (target.health <= 0) {
                            target.zombie = true;
                            this.kpsAcc++;
                            this.removeActor(target);
                        }
                    }
                }
            }
            actors = cell.actors.concat();
            for (let target of actors) {
                if (target instanceof Building) {
                    continue;
                }
                if (building.zombie) {
                    return;
                }
                let attack = target.attack();
                if (attack > building.armor) {
                    let dmg = target.damage();
                    // тут дамаг вкатывается в наши здания, пох на него
                    building.health -= dmg;
                    if (building.health <= 0) {
                        building.zombie = true;
                        this.removeActor(building);
                    }
                }
            }
        }

    }

    public makeSniperShot(building: Building, skipDamage: boolean = false): Shot {
        let shot = new Shot();
        let target = this.selectTargetForSniper(building);
        if (!target) {
            return null;
        }
        if (!skipDamage) {
            let attack = building.attack();
            if (attack > target.armor) {
                let dmg = building.damage();
                target.health -= dmg;
                if (target.health <= 0) {
                    this.kpsAcc++;
                    target.zombie = true;
                    this.removeActor(target);
                }
            }
        }

        let pos = new PIXI.Point();
        pos.copy(target.position);
        shot.targetPosition = pos;
        shot.targetMobs.push(target);

        return shot;
    }

    public selectTargetForSniper(bld:Building): Mob {
        if (bld.name == DictNames.mortar) {
            if (this.ponies.length > 0) {
                return this.ponies[0];
            }
        }
        if (this.bears.length > 0) {
            let index = (Math.random() * this.bears.length) | 0;
            return this.bears[index];
        }
        let cell = this.findCellForMachineGun();
        if (cell && cell.actors) {
            return cell.actors[0];
        }
        return null;
    }


    public makeBoom(screenX: number, screenY: number, bomber: Mob): void {
        //let shot = new Shot();
        //shot.targetPosition = new PIXI.Point(screenX, screenY);
        //let shotMobs = shot.targetMobs;
        let actors = this.getActorsInRadius(screenX, screenY, bomber.boomRadius);
        for (let target of actors) {
            let attack = bomber.attack();
            if (attack > target.armor) {
                let dmg = bomber.damage();
                target.health -= dmg;
                //shotMobs.push(target);
                if (target.health <= 0) {
                    target.zombie = true;
                    this.kpsAcc++;
                    this.removeActor(target);
                }
            }
        }
    }

    private getActorsInRadius(screenX: number, screenY: number, pixelRadius: number): Array<Mob> {
        let res: Array<Mob> = [];
        let cellXTL = ((screenX - pixelRadius) / this.cellPixelsSize) | 0;
        let cellYTL = ((screenY - pixelRadius) / this.cellPixelsSize) | 0;
        let cellXBR = ((screenX + pixelRadius) / this.cellPixelsSize) | 0;
        let cellYBR = ((screenY + pixelRadius) / this.cellPixelsSize) | 0;
        cellXTL = DnDUtils.clamp(cellXTL, 0, this.fieldCellsWidth - 1);
        cellYTL = DnDUtils.clamp(cellYTL, 0, this.fieldCellsHeight - 1);
        cellXBR = DnDUtils.clamp(cellXBR, 0, this.fieldCellsWidth - 1);
        cellYBR = DnDUtils.clamp(cellYBR, 0, this.fieldCellsHeight - 1);

        for (let i = cellXTL; i <= cellXBR; i++) {
            for (let j = cellYTL; j <= cellYBR; j++) {
                let cell = this.cellsCols[i][j];
                if (!this.isCellInradius(cell, screenX, screenY, pixelRadius)) {
                    continue;
                }
                let actors = cell.actors;
                let l = actors.length;
                for (let actIndex = 0; actIndex < l; actIndex++) {
                    let actor = actors[actIndex];
                    if (/*!(actor instanceof Building) &&*/ !actor.zombie) {
                        res.push(actor);
                    }
                }
            }
        }

        return res;
    }

    public isCellInradius(cell: Cell, screenX: number, screenY: number, radius: number): boolean {
        let cellX = (cell.cellX + 0.5) * this.cellPixelsSize;
        let cellY = (cell.cellY + 0.5) * this.cellPixelsSize;
        let xdelta = cellX - screenX;
        let ydelta = cellY - screenY;
        if (Math.sqrt(xdelta * xdelta + ydelta * ydelta) <= radius) {
            return true
        }
        else return false;
    }

    private getScreenPositopnOfCell(targetCell: Cell): PIXI.Point {
        return new PIXI.Point((targetCell.cellX + 0.5) * this.cellPixelsSize, (targetCell.cellY + 0.5) * this.cellPixelsSize);

    }

    private makeMachineGunShot(building: Building): Shot {
        let shot = new Shot();
        let targetCell = this.findCellForMachineGun();
        if (!targetCell) {
            building.prevShotCell = null;
            return null;
        }

        let shift = 0;
        if (building.prevShotCell) {
            let shiftDelta = targetCell.cellY - building.prevShotCell.cellY;
            shift = (shiftDelta / Math.abs(shiftDelta)) | 0;
            targetCell = this.cellsCols[targetCell.cellX][building.prevShotCell.cellY + shift];
        }
        
        building.prevShotCell = targetCell;
        shot.targetPosition = this.getScreenPositopnOfCell(targetCell);
        let shotMobs = shot.targetMobs;
        let actors = targetCell.actors.concat();
        for (let target of actors) {
            let attack = building.attack();
            if (attack > target.armor) {
                let dmg = building.damage();
                target.health -= dmg;
                shotMobs.push(target);
                if (target.health <= 0) {
                    target.zombie = true;
                    this.kpsAcc++;
                    this.removeActor(target);
                }
            }
        }
        return shot;
    }
    
    public makeElectrickShot(building:Building):void {
        for (let col of this.cellsCols) {
            for (let cell of col) {
                if (cell.actors.length == 0) {
                    continue;
                }
                let actors = cell.actors.concat();
                for (let target of actors) {
                    if (target instanceof Building) {
                        continue;
                    }
                    let attack = building.attack();
                    if (attack > target.armor) {
                        let dmg = building.damage();
                        target.health -= dmg;
                        if (target.health <= 0) {
                            target.zombie = true;
                            this.kpsAcc++;
                            this.removeActor(target);
                        }
                    }
                }
            }
        }
    }

    public addActor<T extends Mob>(mob: T): T {
        if (mob.zombie) {
            throw new PandaError('do not add zombies to the world');
        }
        let cell = this.getCellForScreenCoords(mob.x, mob.y);
        cell.addActor(mob);
        mob.lastCellX = cell.cellX;
        mob.lastCellY = cell.cellY;
        if (mob instanceof Building) {
            this.buildings.push(mob);
            this.recheckMovableCells();
        }
        if (mob.name == DictNames.bear) {
            this.bears.push(mob);
        }

        if (mob.name == DictNames.pony) {
            this.ponies.push(mob);
        }
        return mob;
    }

    public removeActor(mob: Mob): Mob {
        if (!mob) {
            return null;
        }
        if (!mob.cell) {
            throw new PandaError('attemt to remove actor form world, but actor is not child');
        }
        mob.cell.removeActor(mob);
        if (mob instanceof Building) {
            let index = this.buildings.indexOf(mob);
            this.buildings.splice(index, 1);
            this.recheckMovableCells();
        }
        if (mob.name == DictNames.bear) {
            let index = this.bears.indexOf(mob);
            this.bears.splice(index, 1);
        }
        if (mob.name == DictNames.pony) {
            let index = this.ponies.indexOf(mob);
            this.ponies.splice(index, 1);
        }
        return mob;
    }

    public actorMoved(mob: Mob): void {
        if (mob.zombie) {
            return;
        }
        let mobx = mob.x;
        let moby = mob.y;
        let inField = mobx >= 0 && moby >= 0 && mobx < this.fieldPixelsWidth && moby < this.fieldPixelsHeight;
        if (mob.cell) {
            if (!inField) {
                this.removeActor(mob);
                return;
            }
        } else {
            if (inField) {
                this.addActor(mob);
            } else {
                return;
            }
        }

        let newCellX = (mobx / this.cellPixelsSize) | 0;
        let newCellY = (moby / this.cellPixelsSize) | 0;

        if (newCellX == mob.lastCellX && newCellY == mob.lastCellY) {
            return;
        }

        let prevCell = mob.cell;
        prevCell.removeActor(mob);
        let cell = this.cellsCols[newCellX][newCellY];
        if (cell == prevCell) {
            throw new PandaError('Mob moved to same cell');
        }
        mob.lastCellX = newCellX;
        mob.lastCellY = newCellY;
        cell.addActor(mob);
        return;
    }


    public getCellForScreenCoords(screenX: number, screenY: number): Cell {
        let cellX = (screenX / this.cellPixelsSize) | 0;
        let cellY = (screenY / this.cellPixelsSize) | 0;

        return this.cellsCols[cellX][cellY];
    }

    public findCellForMachineGun(): Cell {
        let l = this.cellsCols.length;
        for (let i = l - 1; i >= 3; i--) {
            let cell = this.findMaxSummaryHeathInCol(this.cellsCols[i]);
            if (cell) {
                return cell;
            }
        }
        return null;
    }

    public findMaxSummaryHeathInCol(col: Array<Cell>): Cell {
        let maxCell: Cell = null;
        let max = 0; // нам не нужны ячейки с 0 хелфов
        for (let cell of col) {
            let sumHeath = cell.getSummaryHealth();
            if (sumHeath > max) {
                max = sumHeath;
                maxCell = cell;
            }
        }
        return maxCell;
    }
}